import { t } from '@/features/i18n/utils';
import { useAtomValue } from 'jotai';
import { useAuth } from '@/features/auth';
import { recentWorkspacesAtom } from '@/features/workspaces/store';
import { recentWorkspacesKey } from '@/features/workspaces/utils';
import { WorkspaceTypeIcon } from '@/features/workspaces/components/workspace-type-icon';
import {
  SidebarHeading,
  SidebarSection,
  SidebarSectionPanel,
  SidebarItem,
  SidebarLink,
  SidebarList,
  SidebarListEmpty,
  SidebarListEmptyIcon,
} from '@/ui/components/sidebar';
import { FolderLibraryIcon } from '@hugeicons-pro/core-stroke-rounded';
import { HoverScrollText } from '@/ui/components/hover-scroll-text';

export function RecentWorkspaces() {
  const auth = useAuth();
  const recentWorkspacesByOrg = useAtomValue(recentWorkspacesAtom);
  const recentWorkspaces =
    recentWorkspacesByOrg[recentWorkspacesKey(auth.user.organizationId)] ?? [];

  return (
    <SidebarSection id="recent-workspaces">
      <SidebarHeading>{t({ en: 'Recent workspaces', nb: 'Nylige arbeidsområder' })}</SidebarHeading>
      <SidebarSectionPanel>
        {recentWorkspaces.length === 0 ? (
          <SidebarListEmpty>
            <SidebarListEmptyIcon icon={FolderLibraryIcon} />
            {t({ en: 'Recent workspaces show up here', nb: 'Nylige arbeidsområder vises her' })}
          </SidebarListEmpty>
        ) : (
          <SidebarList>
            {recentWorkspaces.map((workspace) => (
              <SidebarItem key={workspace.id}>
                <SidebarLink
                  to="/project/$projectId/workspaces/$workspaceId"
                  params={{ projectId: workspace.projectId, workspaceId: workspace.id }}
                  data-inactive
                >
                  <WorkspaceTypeIcon type={workspace.type} />
                  <HoverScrollText>{workspace.name}</HoverScrollText>
                </SidebarLink>
              </SidebarItem>
            ))}
          </SidebarList>
        )}
      </SidebarSectionPanel>
    </SidebarSection>
  );
}
